import { ADMIN_URLS } from '../config/adminApi';
import { createApiClient } from '../lib/http';

const api = createApiClient();

export interface AdminNotification {
  id: string;
  type: 'password_reset_mobile' | 'password_reset_admin' | 'password_reset_request';
  read: boolean;
  createdAt: string;
  // Mobile OTP reset : ni code ni jeton de session dans la notification ; un
  // code frais se génère à la demande (generateMobileResetCode).
  phoneNumber?: string;
  // Admin email reset : la notification ne porte JAMAIS de lien (secret
  // porteur) ; un lien frais se génère à la demande (generateAdminResetLink).
  email?: string;
  // Demande de reset médiée par l'admin (sans SMS)
  userId?: string;
  name?: string;
  userType?: string;
}

export interface NotificationsResponse {
  success: boolean;
  notifications: AdminNotification[];
  unreadCount: number;
  total: number;
  error?: string;
}

export interface AdminResetLinkResponse {
  success: boolean;
  /** Lien frais, à usage unique : jamais stocké, ne pas le conserver. */
  resetLink: string | null;
  /** Sans lien (Admin SDK indisponible) : Firebase a-t-il envoyé l'email ? */
  emailEnvoye: boolean;
}

export interface MobileResetCodeResponse {
  success: boolean;
  /** Code frais : invalide le précédent, jamais stocké, ne pas le conserver. */
  otpCode: string;
  /** Validité du code, en secondes. */
  expiresIn: number;
}

export const adminNotificationsApi = {
  async getNotifications(unreadOnly = false, limit = 50): Promise<NotificationsResponse> {
    const { data } = await api.get<NotificationsResponse>(`${ADMIN_URLS.notifications}`, {
      params: { unread_only: unreadOnly, limit },
    });
    return data;
  },

  async getUnreadCount(): Promise<number> {
    const { data } = await api.get<{ unreadCount?: number }>(`${ADMIN_URLS.notifications}/unread-count`);
    return data.unreadCount ?? 0;
  },

  async markAsRead(notificationId: string): Promise<void> {
    await api.patch(`${ADMIN_URLS.notifications}/${notificationId}/read`);
  },

  async markAllRead(): Promise<void> {
    await api.patch(`${ADMIN_URLS.notifications}/mark-all-read`);
  },

  /** Super admin : génère un lien frais de réinitialisation (action auditée). */
  async generateAdminResetLink(notificationId: string): Promise<AdminResetLinkResponse> {
    const { data } = await api.post<AdminResetLinkResponse>(
      `${ADMIN_URLS.notifications}/${notificationId}/reset-link`,
    );
    return data;
  },

  /** Super admin : émet un code frais pour une demande mobile (action auditée). */
  async generateMobileResetCode(notificationId: string): Promise<MobileResetCodeResponse> {
    const { data } = await api.post<MobileResetCodeResponse>(
      `${ADMIN_URLS.notifications}/${notificationId}/otp-code`,
    );
    return data;
  },
};
